import React, {useState} from 'react';
import {Alert, Button, Spinner} from 'react-bootstrap';
import {getFunctions, httpsCallable} from 'firebase/functions';
import RestartAltIcon from '@mui/icons-material/RestartAltRounded';

const RebootDevice = ({eid}) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [confirming, setConfirming] = useState(false);

  const handleReboot = async () => {
    if (!confirming) {
      setConfirming(true);
      return;
    }

    setConfirming(false);
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const functions = getFunctions(undefined, 'europe-west1');
      const rebootEdgeFn = httpsCallable(functions, 'rebootEdge');
      await rebootEdgeFn({edgeId: eid});
      setResult('Device reboot triggered successfully. Templates have been refreshed.');
    } catch (err) {
      console.error('Reboot failed:', err);
      setError(err.message || 'Failed to reboot device');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setConfirming(false);
  };

  return (
    <div className="island p-4">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <h6 className="mb-1" style={{color: 'var(--text-primary)'}}>
            <RestartAltIcon className="me-2" style={{marginBottom: 2, fontSize: 20}}/>
            Reboot Device
          </h6>
          <p className="mb-0 small" style={{color: 'var(--text-secondary)'}}>
            Fully restart the edge device and push the latest configuration with updated templates.
          </p>
        </div>
        <div className="d-flex align-items-center gap-2">
          {confirming && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </Button>
          )}
          <Button
            variant={confirming ? 'danger' : 'outline-danger'}
            size="sm"
            onClick={handleReboot}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size="sm" animation="border" className="me-1"/>
                Rebooting...
              </>
            ) : confirming ? (
              'Confirm Reboot'
            ) : (
              'Reboot'
            )}
          </Button>
        </div>
      </div>
      {result && (
        <Alert variant="success" className="mt-3 mb-0 py-2 px-3" style={{fontSize: '0.9rem'}}>
          {result}
        </Alert>
      )}
      {error && (
        <Alert variant="danger" className="mt-3 mb-0 py-2 px-3" style={{fontSize: '0.9rem'}}>
          {error}
        </Alert>
      )}
    </div>
  );
};

export default RebootDevice;
